import {useEffect, useState} from "react";
import {useApp} from "../Contex";
import {createUser, removeUser, fetchRoles, fetchUsers, updateUser, createNewPassword} from "../api/api";
import BottomSheet from "../components/BottomSheet";
import Select from "react-select";

export default function UsersPage(){
    const {refresh, permissions: {write}, userName} = useApp()
    const [users, setUsers] = useState([])
    const [roles, setRoles] = useState([])
    const [addUser, setAddUser] = useState(false)
    const [editUser, setEditUser] = useState(null)
    const [userToRemove, setUserToRemove] = useState(null)
    const [newPass, setNewPass] = useState(null)

    const fetchData = () => {
        fetchUsers().then((res)=>{
            if(res.ok){
                setUsers(res.users)
            }
        })

        fetchRoles().then((res)=>{
            if(res.ok){
                setRoles(res.roles)
            }
        })
    }

    const handleDelete = (id) =>{
        removeUser(id).then((res)=>{
            if(res.ok){
                fetchData()
            }
        })
    }

    const handleSave = (user) => {
        updateUser(user).then((res)=>{
            if(res.ok){
                fetchData()
            }
        })
    }

    useEffect(() => {
        fetchData()
    }, [refresh]);
    return <>
        <div className="d-flex align-items-center justify-content-between align-items-center mb-2">
            <h1>Användare</h1>
            {write &&
                <button className="btn btn-success" onClick={()=>{setAddUser(true)}}>
                    <span>Skapa ny </span>
                    <i className="bi bi-plus-square"/>
                </button>
            }
        </div>
        {users.map(user => (
            <div key={user["_id"]} className="card p-2 rounded shadow-sm mb-2 flex-row justify-content-between align-items-start">
                <div>
                <h5 className="mb-0">{user.email}</h5>
                <span>{user.role.name}</span>
                </div>
                <div>
                    {write && user.email !== userName && <>
                    <button className="btn btn-outline-secondary me-2" onClick={()=>{setEditUser(user)}}>
                        <i className="bi bi-pencil-square"/>
                    </button>
                    <button className="btn btn-outline-danger" onClick={()=>{setUserToRemove(user["_id"])}}>
                        <i className="bi bi-trash"/>
                    </button>
                    </>}
                </div>
            </div>
            ))}
        <AddModal/>
        <EditModal/>
        <PassModal/>
        <DeleteModal/>
    </>

    function AddModal() {
        const [user, setUser] = useState({ email: "", role: "" });
        const [error, setError] = useState(null);
        const options = roles.map((role) => ({
            value: role._id,
            label: role.name
        }));

        const selectedRole = options.find(opt => opt.value === user.role) || null;

        const handleSubmit = () => {
            if (!user.email || !user.role) {
                setError("Fyll i både e-post och roll.");
                return;
            }
            createUser(user).then(res=>{
                if(res.ok){
                    setAddUser(false)
                    if(res.data.created){
                        setNewPass(res.data.password)
                    }else{
                        fetchData()
                    }
                }else{
                    setError(res.error)
                }
            })
        };

        const isFormValid = user.email && user.role;

        return (
            <BottomSheet show={addUser} setShow={setAddUser}>
                    <h4 className="mb-3">Ny användare</h4>

                    <div className="mb-3">
                        <label className="form-label">E-post</label>
                        <input
                            type="email"
                            className="form-control"
                            value={user.email}
                            onChange={(e) =>
                                setUser((prev) => ({ ...prev, email: e.target.value }))
                            }
                            placeholder="anvandare@example.com"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Roll</label>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            value={selectedRole}
                            options={options}
                            onChange={(e) =>
                                setUser((prev) => ({ ...prev, role: e.value }))
                            }
                            placeholder="Välj en roll..."
                        />
                    </div>

                    {error && (
                        <div className="alert alert-danger py-2 px-3 mb-3">
                            {error}
                        </div>
                    )}

                    <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-success d-flex align-items-center gap-2"
                            onClick={handleSubmit}
                            disabled={!isFormValid}
                        >
                            <i className="bi bi-plus-circle" />
                            Skapa
                        </button>
                    </div>
            </BottomSheet>
        );
    }

    function EditModal() {
        const [user, setUser] = useState({email: "", role: {} });
        const [error, setError] = useState(null);
        const [changed, setChanged] = useState(false);

        useEffect(() => {
            if(editUser){
                setUser(editUser)
            }else{
                setUser({email: "", role: {}});
            }

        }, [editUser]);

        // Options for the role dropdown
        const options = roles.map((role) => ({
            value: role._id,
            label: role.name
        }));

        // Get selected role from user's current role object (from DB)
        const selectedRole = options.find(
            opt => opt.value === (user.role?._id || user.role)
        ) || null;

        const handleSubmit = async () => {
            try {
                // Replace role object with just the role ID before sending
                const updatedUser = {
                    ...user,
                    role: selectedRole.value
                };

                handleSave(updatedUser)

                setChanged(false);
                setEditUser(null); // Close modal after save
            } catch (err) {
                setError("Kunde inte spara användaren.");
                console.error("[EditModal] Submit error", err);
            }
        };

        const handleNewPass = () => {
            const updatedUser = {
                ...user,
                role: selectedRole.value
            };
            createNewPassword(updatedUser).then(res=>{
                if(res.ok){
                    setEditUser(null)
                    setNewPass(res.password)
                }
            })
        }

        const isFormValid = !!user.email && !!selectedRole;

        return (
            <BottomSheet show={editUser} setShow={setEditUser}>
                <div className="d-flex align-items-center gap-2 mb-2">
                    <h4 className="mb-0">Redigera användare</h4>
                    <button className="btn btn-outline-danger" onClick={()=>{
                        setUserToRemove(user["_id"])
                        setEditUser(null)
                    }}><i className="bi bi-trash"/></button>
                </div>

                <div className="mb-3">
                    <label className="form-label">E-post</label>
                    <input
                        type="email"
                        className="form-control"
                        value={user.email}
                        onChange={(e) => {
                            setUser(prev => ({ ...prev, email: e.target.value }));
                            setChanged(true);
                        }}
                        placeholder="anvandare@example.com"
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">Roll</label>
                    <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        value={selectedRole}
                        options={options}
                        onChange={(selected) => {
                            setUser(prev => ({ ...prev, role: selected.value }));
                            setChanged(true);
                        }}
                        placeholder="Välj en roll..."
                    />
                </div>

                <div className="mb-3">
                    <p className="form-label mb-1">Skapa nytt lösenord</p>
                    <button className="btn btn-danger" onClick={handleNewPass}>Nytt lösenord</button>
                </div>

                {error && (
                    <div className="alert alert-danger py-2 px-3 mb-3">
                        {error}
                    </div>
                )}

                <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-success d-flex align-items-center gap-2"
                            onClick={handleSubmit}
                            disabled={!isFormValid || !changed}
                        >
                            <i className="bi bi-save2" />
                            Spara
                        </button>
                </div>
            </BottomSheet>
        );
    }

    function PassModal() {
        const [copied, setCopied] = useState(false);

        const handleCopy = () => {
            navigator.clipboard.writeText(newPass).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            });
        };

        return (
            <BottomSheet show={!!newPass} setShow={setNewPass} onClose={fetchData}>
                    <h4 className="mb-2">Nytt lösenord skapat</h4>
                    <p className="text-muted mb-4">
                        Detta är det temporära lösenordet för användaren. Kopiera och spara det – det kommer inte visas igen.
                    </p>

                    <div className="d-flex align-items-center gap-2 mb-3">
                    <span className="form-control text-monospace w-auto mb-0" style={{ minWidth: "200px" }}>
                        {newPass}
                    </span>
                        <button className="btn btn-secondary" onClick={handleCopy}>
                            {copied ? <i className="bi bi-clipboard-check"/>  : <i className="bi bi-clipboard"/>}
                        </button>
                    </div>
            </BottomSheet>
        );
    }

    function DeleteModal(){
            return <BottomSheet show={userToRemove} setShow={setUserToRemove}>
                <h2>Bekräfta borttagning</h2>
                <p>Är du säker på att du vill ta bort användaren?</p>
                <div className="text-end">
                    <div className="d-flex gap-2">
                        <button className="btn btn-secondary" onClick={()=>{setUserToRemove(null)}}>
                            Avbryt
                        </button>
                        <button className="btn btn-outline-danger" onClick={()=>{
                            handleDelete(userToRemove)
                            setUserToRemove(null)
                        }}>
                            Bekräfta
                        </button>
                    </div>
                </div>
            </BottomSheet>
    }


}

